import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  defaultText: {
    fontFamily: 'Inter',
    fontSize: 16,
    color: theme.colors.newUI.therapist.textBlue100,
  },
});
